export default __webpack_public_path__ + "static/media/Free.9966ac1d.svg";